import React from 'react';
import { useSmartCardContext } from '@atlaskit/link-provider';
export var WithCardContext = function WithCardContext(_ref) {
  var children = _ref.children;
  var cardContext = useSmartCardContext();
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(cardContext));
};